/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HIcon24Regular = forwardRef('UiMenuDots3HIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.62 12.002a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0Z" }),
        React.createElement("path", { d: "M11.998 13.877a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Z" }),
        React.createElement("path", { d: "M19.5 13.878a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Z" })));
});
